import { AxiosRequestConfig, AxiosResponse } from "axios";
import { Api } from "./Api";
import { apiConfig } from "../config/apiConfig";

class StateApi extends Api {
    public constructor(apiConfig: AxiosRequestConfig) {
      super(apiConfig);
  
      this.updateState = this.updateState.bind(this);
    }

    public getState = async () =>
      await this.get("/front_end_state")
        .then((response: AxiosResponse) => response);

    public getFilingDate = () => this.get("/filing_dates");
  
    public updateState = async (payload: any) =>
      await this.put("/front_end_state", payload)
        .then((response: AxiosResponse) => response);

    public createState = async (payload: any) =>
      await this.post("/front_end_state", payload)
        .then((response: AxiosResponse) => response);
}

  
export const stateApi = new StateApi(apiConfig);
  
